import { render, staticRenderFns } from "./IbLoaderOverlay.vue?vue&type=template&id=3132a589&scoped=true"
import script from "./IbLoaderOverlay.vue?vue&type=script&lang=js"
export * from "./IbLoaderOverlay.vue?vue&type=script&lang=js"
import style0 from "./IbLoaderOverlay.vue?vue&type=style&index=0&id=3132a589&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3132a589",
  null
  
)

export default component.exports